<template>
  <div :key="templateObj.title" :style="templateObj.style" :class="templateObj.className">
    <div v-for="_item in templateObj.htmlStyleList" :key="_item.id">
      <!-- 视频 -->
      <video
        autoplay
        width="100%"
        :class="_item.className"
        v-if="_item.label == 'video'"
        :src="_item.url ? _item.url : videoUrl"
        :style="_item.style"
      ></video>
      <!-- 图片 -->
      <el-image
        class="imageClass"
        :class="_item.className"
        v-if="_item.label == 'image'"
        :src="_item.src ? _item.src : defaultPic"
        fit="cover"
        :style="_item.style"
      ></el-image>
      <!-- 文本 -->
      <div v-if="_item.label == 'div'" :style="_item.style" :class="_item.className">
        {{ _item.attribute == "custom" ? _item.custom : _item.title }}
      </div>
      <!-- 矢量图 -->
      <div
        class="yh-iconfont"
        :class="[_item.icon, _item.className]"
        v-if="_item.label == 'icon'"
        :style="_item.style"
      ></div>
      <!-- 列表 -->
      <div
        class="flexList"
        v-if="_item.label == 'list'"
        :style="_item.style"
        :class="_item.className"
      >
        <div v-for="(Item, _index) in 3" :key="_index">
          <div
            :style="_item.htmlStyleList[0].style"
            :class="_item.htmlStyleList[0].className"
          >
            列表{{ _index }}
          </div>
        </div>
      </div>
      <!-- 栅格 -->
      <el-row
        class="rowhoverClass"
        v-if="_item.label == 'row'"
        :style="_item.style"
        :class="_item.className"
      >
        <el-col :span="Item.col" v-for="Item in _item.htmlStyleList" :key="Item.id">
          <video
            autoplay
            width="100%"
            :class="Item.className"
            v-if="Item.label == 'video'"
            :src="Item.url ? Item.url : videoUrl"
            :style="Item.style"
          ></video>
          <el-image
            :key="_item.title"
            :style="Item.style"
            :class="Item.className"
            v-if="Item.label == 'image'"
            :src="Item.src ? Item.src : defaultPic"
            fit="cover"
          ></el-image>
          <div
            :key="_item.title"
            v-if="Item.label == 'div'"
            :style="Item.style"
            :class="Item.className"
          >
            {{ Item.attribute == "custom" ? Item.custom : Item.title }}
          </div>
          <div
            class="yh-iconfont"
            :class="[Item.icon, Item.className]"
            v-if="Item.label == 'icon'"
            :style="Item.style"
          ></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import zuHeTemplate from "./zuHeTemplate";
export default {
  name: "zuhesubTemplate",
  props: { item: Object },
  components: {
    zuHeTemplate,
  },
  data() {
    return {
      templateObj: [],
      videoUrl:
        "http://1251150518.vod2.myqcloud.com/8d224e9cvodgzp1251150518/a775f1ae3701925920751120030/4RPCJ58Vki4A.mp4",
      defaultPic:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
    };
  },
  watch: {
    item: {
      handler() {
        this.initData();
      },
      deep: true,
    },
  },
  methods: {
    initData() {
      let obj = JSON.parse(JSON.stringify(this.item));
      obj.htmlStyleList = this.getDynamicList(this.item.htmlStyleList);
      this.templateObj = obj;
    },
    getDynamicList(arr) {
      let newArr = [];
      arr.forEach((item) => {
        let itemArr = [];
        if (item.htmlStyleList.length != 0) {
          item.htmlStyleList.forEach((_item) => {
            _item = this.objectAssign(_item);
            itemArr.push(_item);
          });
        }
        item = this.objectAssign(item);
        item.htmlStyleList = itemArr;
        newArr.push(item);
      });
      return newArr;
    },
    //对象合并
    objectAssign(obj) {
      let jsonObj = JSON.parse(obj.styleJson);
      return Object.assign({}, jsonObj, obj);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style scoped>
.el-image {
  width: 100%;
}

.imageClass {
  display: block;
  object-fit: cover;
  max-width: 100%;
  max-height: 100%;
}
.flexList {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineTemplate/template/zuhesubTemplate.vue